"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var firebase = _interopRequireWildcard(require("firebase/app"));

require("firebase/performance");

var _index = require("./compatibility/index");

var _hack = require("./utils/hack");

var navigation = _interopRequireWildcard(require("./record/navigation"));

var api = _interopRequireWildcard(require("./record/api"));

var frame = _interopRequireWildcard(require("./record/frame"));

var action = _interopRequireWildcard(require("./record/action"));

var page = _interopRequireWildcard(require("./record/page"));

var _routerBeforeChange = _interopRequireDefault(require("./utils/routerBeforeChange"));

var _runtime = _interopRequireDefault(require("./utils/runtime"));

var _path = require("./utils/path");

var _logger = _interopRequireDefault(require("./logger"));

var _mutationObserver = require("./mutationObserver");

var _storage = _interopRequireDefault(require("./utils/storage"));

var _transport = require("./transport");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var firebaseApp;
var readyCallbacks = [];

var firebaseReadyCallback = function firebaseReadyCallback(callback) {
  if (typeof callback !== 'function') {
    return false;
  }

  if (!firebaseApp) {
    readyCallbacks.push(callback);
  } else {
    callback();
  }
};

function invokeCallbacks() {
  readyCallbacks.forEach(function (cb) {
    cb();
  });
  readyCallbacks = [];
}

function processRouteNameMap(routeBase) {
  var routeNameMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var nameMap = {};
  var base = (0, _path.removeTrailingSlash)(routeBase);
  Object.keys(routeNameMap).forEach(function (key) {
    var value = routeNameMap[key];
    var k = (0, _path.addLeadingSlash)((0, _path.removeTrailingSlash)(key));
    var p = (0, _path.addLeadingSlash)("".concat(base).concat(k));
    nameMap[p] = value;
  });
  return nameMap;
}

function processRouteConfig(routeBase) {
  var routeConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var config = {};
  var base = (0, _path.removeTrailingSlash)(routeBase);
  Object.keys(routeConfig).forEach(function (key) {
    var value = routeConfig[key].name || routeConfig[key];
    var k = (0, _path.addLeadingSlash)((0, _path.removeTrailingSlash)(key));
    var p = (0, _path.addLeadingSlash)("".concat(base).concat(k));
    config[p] = _objectSpread({}, routeConfig[key]);
  });
  return config;
}

function mergeNameMapToConfig(nameMap, config) {
  Object.keys(nameMap).forEach(function (key) {
    if (!config[key]) {
      config[key] = {
        name: nameMap[key],
        firebase: {
          enabled: true
        }
      };
    }
  });
  return config;
}

function setRuntimeVars(_ref) {
  var config = _ref.config,
      env = _ref.env,
      pageMode = _ref.pageMode,
      routeNameMap = _ref.routeNameMap,
      routeBase = _ref.routeBase,
      routeConfig = _ref.routeConfig,
      shouldLog = _ref.shouldLog,
      shouldReport = _ref.shouldReport,
      whiteApiDomain = _ref.whiteApiDomain;

  _runtime.default.set('env', env);

  _runtime.default.set('pageMode', pageMode);

  _runtime.default.set('whiteApiDomain', whiteApiDomain);

  if (env !== 'prod') {
    _runtime.default.set('shouldLog', shouldLog);

    _runtime.default.set('shouldReport', shouldReport);
  } // const nameMap = processRouteNameMap(routeBase, routeNameMap)
  // runtime.set('routeNameMap', nameMap)


  var nameMap = processRouteNameMap(routeBase, routeNameMap);
  var configMap = processRouteConfig(routeBase, routeConfig);
  var routeConfigMap = mergeNameMapToConfig(nameMap, configMap);

  _runtime.default.set('routeConfig', routeConfigMap);
}

function checkRequiredOptions(_ref2) {
  var config = _ref2.config,
      env = _ref2.env,
      pageMode = _ref2.pageMode,
      routeNameMap = _ref2.routeNameMap,
      routeConfig = _ref2.routeConfig;

  // if (config && env && pageMode && routeNameMap) {
  //   return true
  // }
  if (env && pageMode && (routeConfig || routeNameMap)) {
    if (!routeConfig && routeNameMap) {
      _logger.default.error('[performance collect] routeNameMap 配置已废弃，请使用 routeConfig');
    }

    return true;
  }

  _logger.default.error('[firebase] config, env, pageMode, routeConfig 必填！');

  return false;
}

function checkWhiteApiDomainType(_ref3) {
  var whiteApiDomain = _ref3.whiteApiDomain;

  if (Array.isArray(whiteApiDomain)) {
    return true;
  }

  _logger.default.error('[firebase] whiteApiDomain 必须是数组！');

  return false;
}

function removeDeprecatedData() {
  try {
    _storage.default.clear({
      key: 'LOCAL_STORAGE_ACTION_3ef705fd'
    });

    _storage.default.clear({
      key: 'LOCAL_STORAGE_FRAME_11a7e258'
    });
  } catch (error) {
    _logger.default.error(error);
  }
}

var init = function init(_ref4) {
  var config = _ref4.config,
      env = _ref4.env,
      pageMode = _ref4.pageMode,
      routeNameMap = _ref4.routeNameMap,
      _ref4$routeBase = _ref4.routeBase,
      routeBase = _ref4$routeBase === void 0 ? '/' : _ref4$routeBase,
      routeConfig = _ref4.routeConfig,
      _ref4$shouldLog = _ref4.shouldLog,
      shouldLog = _ref4$shouldLog === void 0 ? false : _ref4$shouldLog,
      _ref4$shouldReport = _ref4.shouldReport,
      shouldReport = _ref4$shouldReport === void 0 ? false : _ref4$shouldReport,
      _ref4$whiteApiDomain = _ref4.whiteApiDomain,
      whiteApiDomain = _ref4$whiteApiDomain === void 0 ? [] : _ref4$whiteApiDomain;

  if (!checkRequiredOptions({
    config: config,
    env: env,
    pageMode: pageMode,
    routeNameMap: routeNameMap,
    routeConfig: routeConfig
  })) {
    return false;
  }

  if (!(0, _index.checkCompat)(env)) {
    return false;
  }

  if (!checkWhiteApiDomainType({
    whiteApiDomain: whiteApiDomain
  })) {
    return false;
  }

  setRuntimeVars({
    config: config,
    env: env,
    pageMode: pageMode,
    routeNameMap: routeNameMap,
    routeConfig: routeConfig,
    routeBase: routeBase,
    shouldLog: shouldLog,
    shouldReport: shouldReport,
    whiteApiDomain: whiteApiDomain
  });
  removeDeprecatedData();
  (0, _hack.hackLocalStorage)();
  (0, _hack.hackFetch)();
  (0, _transport.setUpTransport)();

  if (config) {
    // hot reload会导致重复挂载
    if (!firebase.apps.length) {
      firebaseApp = firebase.initializeApp(config);
      invokeCallbacks();
    }

    (0, _hack.initHack)();
  }

  _hack.performanceInitializationPromise.then(function () {
    navigation.init();
    api.init();
    frame.init();
    action.init();
  });

  (0, _mutationObserver.startObserver)(page.observeCallback); // 路由变化时通知对应方法执行

  (0, _routerBeforeChange.default)([function () {
    return page.whenRouterChange();
  }, function () {
    return frame.whenRouterChange();
  }, function () {
    return action.whenRouterChange();
  }]);
};

var _default = {
  init: init,
  recordPagePerformance: page.recordPagePerformance,
  getPageMode: page.getPageMode,
  writeFrameData: frame.writeFrameData,
  reportPageInteractive: function reportPageInteractive() {
    _logger.default.error('此方法已废弃，请使用 recordPagePerformance 方法');
  },
  setDeviceLevel: function setDeviceLevel(level) {
    _runtime.default.set('deviceLevel', level);
  },
  firebase: firebase,
  firebasePerformance: firebase.performance,
  firebaseReadyCallback: firebaseReadyCallback
};
exports.default = _default;